var opts = {
    timeout: 400,
    interval: 50
};

var topCart = document.querySelector('#shop-cart');

topCart && hoverintent(topCart,
    function() {
        this.className = 'hover';
    },
    function() {
        this.className = 'no-hover';
    }).options(opts);

var topNav = document.querySelectorAll('.top-nav > li');

for (var i = 0; i < topNav.length; i++) {
    var currentHover = topNav[i];
    hoverintent(currentHover,
        function() {
            this.className = 'dropdown open';
        },
        function() {
            this.className = 'dropdown';
        }).options(opts);
}

function addEvent(object, event, method) {
    if (object.attachEvent) {
        object['e' + event + method] = method;
        object[event + method] = function() {
            object['e' + event + method](window.event);
        };
        object.attachEvent('on' + event, object[event + method]);
    } else {
        object.addEventListener(event, method, false);
    }
}
